import * as React from 'react';
import { SVGProps } from 'react';

const IconMapsSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 6 1 9l.968 4.333L5.167 15l4.166-1.25L11 10.833l-.968-4.166L6.806 5 3 6Z"
      fill="var(--color-typo-caution)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m2.07 9.2.772 3.461 2.426 1.264 3.395-1.018 1.274-2.23-.774-3.334-2.474-1.278-3.068.806L2.07 9.199ZM3 6 1 9l.968 4.333L5.167 15l4.166-1.25L11 10.833l-.968-4.166L6.806 5 3 6Z"
      fill="var(--color-typo-primary)"
    />
    <path
      d="M6 2 4 5.5 5 10l3.5 2 5-1.5 1.5-3L14 3l-3.5-2L6 2Z"
      fill="var(--color-typo-caution)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.5 12-2.745-1.569-.031.016L5.7 10.4 5 10 4 5.5 6 2l4.5-1L14 3l1 4.5-1.5 3-5 1.5ZM5.184 6.217l.676 3.044 2.458-1.229L11.93 7h1.934l-.666-3H11.07l-3.388.968-2.498 1.25Zm.276-1.256 1.858-.929L10.93 3h1.054l-1.645-.94-3.69.82-1.19 2.081Zm3.222 4.007-1.852.926 1.794 1.025 4.175-1.253L13.632 8H12.07l-3.388.968Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconMapsSizeS;
